import React, { Suspense, lazy } from 'react';
import ReactionsContext from './ReactionsContext';
import LoadingPlaceholder from 'components/LoadingPlaceholder';

import './style.scss';

const Emojis = lazy(() => import('./Emojis'));

function Reactions({ activity, children }) {
  const { hands = 0, smile = 0, laughing = 0, like = 0, heart = 0 } = activity?.activiable?.likes_counts ?? {};

  const reactions = [
    { icon: 'reaction-hands', count: hands },
    { icon: 'reaction-smile', count: smile },
    { icon: 'reaction-laughing', count: laughing },
    { icon: 'reaction-like', count: like },
    { icon: 'reaction-heart', count: heart }
  ].filter(reaction => reaction.count);

  if (!reactions.length) {
    return null;
  }

  return (
    <ReactionsContext.Provider value={reactions}>
      <Suspense fallback={<LoadingPlaceholder />}>{children ?? <Emojis />}</Suspense>
    </ReactionsContext.Provider>
  );
}

Reactions.Emojis = Emojis;

export default Reactions;
